<script>
import bem from '@/utils/bem';
import { mapActions, mapState } from 'vuex';
import TiptapEditor from '@/components/ux/bundleEditor/Tiptap-editor.vue';
import UploadImage from '@/components/ux/upload/Upload-image.vue';

const b = bem('frame-hint');

export default {
  components: {
    UploadImage,
    TiptapEditor,
  },
  props: {
    id: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      isPreview: false,
      isMobile: false,
      editMedia: false,
      editContent: false,
      fileList: [],
      title: '',
      titleMobile: '',
      description: null,
      linkVideo: '',
    };
  },
  methods: {
    b(firstArg, secondArg) {
      return b(firstArg, secondArg);
    },
    ...mapActions({
      getFrameDetailsAction: 'createTemplate/getFrameDetails',
      getHintMediaAction: 'createTemplate/getHintMedia',
      updateProductAction: 'products/updateProduct',
      editImageContentAction: 'createTemplate/editImageContent',
      editIframeContentAction: 'createTemplate/editIframeContent',
    }),
    checkForm() {
      this.isPreview = false;
    },
    checkDesktopReview() {
      this.isPreview = true;
      this.isMobile = false;
    },
    checkMobileReview() {
      this.isPreview = true;
      this.isMobile = true;
    },
    openMedia() {
      console.log('[FrameHint] openMedia - hintMedia:', this.hintMedia);
      // Заполняем fileList существующими изображениями из hintMedia
      // Сохраняем id для отслеживания удалённых
      if (this.hintMedia && this.hintMedia.length > 0) {
        this.fileList = this.hintMedia
          .filter((item) => item.imageUri && !item.iFrame)
          .map((item) => ({
            url: item.imageUri,
            image: item.imageUri,
            hintMediaId: item.id, // Сохраняем id для отслеживания
          }));
        console.log('[FrameHint] openMedia - initialized fileList:', this.fileList);
      }
      this.editMedia = true;
    },
    openContent() {
      this.editContent = true;
    },
    saveMedia() {
      console.log('[FrameHint] saveMedia - fileList:', this.fileList);
      console.log('[FrameHint] saveMedia - hintMedia (oldMedia):', this.hintMedia);
      console.log('[FrameHint] saveMedia - linkVideo:', this.linkVideo);

      if (this.linkVideo.length) {
        const payload = {
          iframe: this.linkVideo,
          oldMedia: this.hintMedia,
          index: 0,
          isAutoPlay: false,
          productId: this.id,
        };
        console.log('[FrameHint] saveMedia - calling editIframeContentAction with:', payload);
        this.editIframeContentAction(payload);
        this.linkVideo = '';
      } else {
        // Новые файлы - те, у которых есть file property
        const newFiles = this.fileList.filter((item) => item.file);

        // Оставшиеся старые - те, у которых есть hintMediaId (не удалены пользователем)
        const remainingOldIds = this.fileList
          .filter((item) => item.hintMediaId)
          .map((item) => item.hintMediaId);

        // Удалённые - те, которые были в hintMedia, но нет в текущем fileList
        const deletedMedia = this.hintMedia.filter(
          (item) => item.id && !remainingOldIds.includes(item.id),
        );

        console.log('[FrameHint] saveMedia - newFiles to upload:', newFiles);
        console.log('[FrameHint] saveMedia - remainingOldIds:', remainingOldIds);
        console.log('[FrameHint] saveMedia - deletedMedia:', deletedMedia);

        const payload = {
          deletedMedia, // Только удалённые
          newMedia: newFiles, // ВСЕ новые файлы
          id: this.id,
        };

        if (deletedMedia.length > 0 || newFiles.length > 0) {
          console.log('[FrameHint] saveMedia - calling editImageContentAction with:', payload);
          this.editImageContentAction(payload);
        } else {
          console.log('[FrameHint] saveMedia - no changes to save');
        }
      }
      this.editMedia = false;
      this.fileList = [];
    },
    saveContent() {
      const payload = {
        id: this.id,
        hint: this.description,
      };
      this.updateProductAction(payload);
      this.editContent = false;
    },
    getVideoUrl() {
      return this.hintMedia[0].iFrame.replace('560', '100%').replace('315', '100%');
    },
  },
  computed: {
    ...mapState({
      frameDetails: (state) => state.createTemplate.frameDetails,
      hintMedia: (state) => state.createTemplate.hintMedia,
    }),
  },
  mounted() {
    this.getFrameDetailsAction(this.id);
    this.getHintMediaAction(this.id);
  },
  watch: {
    frameDetails(newV) {
      this.description = newV.hint;
    },
  },
};
</script>

<template>
  <div class="top-buttons">
    <a-button
      size="large"
      class='buttons-menu-item'
      @click="checkForm()"
      :type="!isPreview ? 'primary' : 'default'"
    >
      Form for data
    </a-button>
    <a-button
      size="large"
      class='buttons-menu-item'
      @click="checkDesktopReview()"
      :type="isPreview && !isMobile ? 'primary' : 'default'"
    >
      Desktop Preview
    </a-button>
    <a-button
      size="large"
      class='buttons-menu-item'
      @click="checkMobileReview()"
      :type="isPreview && isMobile ? 'primary' : 'default'"
    >
      Mobile Preview
    </a-button>
  </div>
  <div  v-if="!isPreview" class="wrap">
    <div class="content-buttons">
      <div class="row">
        <div class="column">
          <a-button
            size="large"
            class='buttons-menu-item'
            @click="editMedia ? saveMedia() : openMedia()"
            :type="editMedia ? 'primary' : 'default'"
            :disabled="editMedia && !linkVideo.length && !fileList.length"
          >
            {{ editMedia ? 'Save new media' : 'Edit media' }}
          </a-button>
          <div class="left-side" v-if="editMedia">
            <h4>Add one image or link for one video</h4>
            <upload-image
              :is-multiple="true"
              :initial-images="fileList"
              v-model:files="fileList"
            />
            <a-input
              placeholder="Enter here link video"
              v-model:value="linkVideo"
              :disabled="fileList.length"
            />
          </div>
        </div>
      </div>
      <div class="row">
        <div class="column">
          <a-button
            size="large"
            class='buttons-menu-item'
            @click="editContent ? saveContent() : openContent()"
            :type="editContent ? 'primary' : 'default'"
          >
            {{ editContent ? 'Save content' : 'Edit content' }}
          </a-button>
          <div class="right-side" v-if="editContent">
            <div class="wrapper">
              <div
                class="description"
                v-html="description"
              />
              <tiptap-editor
                :height="600"
                :width="600"
                :value="description"
                v-model:value="description"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div v-if="isPreview" :class="b('', { isMobile })">
    <div :class="b('content', { isMobile })">
      <div :class="b('container', { isMobile })">
        <div
          v-if="this.hintMedia[0].iFrame && this.hintMedia[0].iFrame[0] === '<'"
          id="videoUrl"
          :class="b('image', { isMobile })"
          v-html="getVideoUrl()"
        />
        <img
          v-else
          :class="b('image', { isMobile })"
          :src="this.hintMedia[0].imageUri"
          alt="image"
        >
        <div
          :class="b('description', { isMobile })"
          v-html="description"
        />
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss">
@import 'src/styles/variables.scss';
@import "src/styles/media.scss";
@import "src/styles/fonts.scss";
.top-buttons {
  width: 1200px;
  margin: 50px auto;
}

.wrap{
  width: 1200px;
  margin: 50px auto;
  display: flex;
  flex-direction: row;
  gap: 20px;
}

.content-buttons {
  display: flex;
  flex-direction: column;
  gap: 50px;
}

.wrapper {
  width: 1200px;
  height: 600px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}

.description {
  width: 42%;
  overflow-y: auto;
  max-height: 600px;
  padding-top: 133px;
}

.buttons-menu-item {
  margin-right: 50px;
}

.headers {
  margin: 20px 0;
  display: flex;
  justify-content: flex-end;
}

.frame-hint {
  width: 100%;
  height: 600px;
  background: $athens-gray-color;
  padding: 20px 0;

  &__content {
    margin: 0 auto;
    width: 1327px;
    height: 557px;
    padding: 30px;
    background: $white-color;

    @include mediaMinMax(1025, $normal) {
      padding: vw-full(30);
    }

    &_isMobile {
      overflow-y: scroll;
      width: 324px;
      height: 567px;
    }
  }

  &__container {
    display: flex;
    flex-direction: row;
    gap: 35px;

    @include mediaMinMax(1025, $normal) {
      gap: vw-full(35);
    }
    &_isMobile {
      overflow-y: scroll;
      flex-direction: column;
      gap: 20px;
    }
  }

  &__image {
    width: 497px;
    height: 497px;
    padding: 7px;
    overflow: hidden;
    display: flex;
    flex-direction: row;
    box-shadow: 10.1px 12.4px 76px 0 rgba(0, 0, 0, 0.07);
    background: $white-color;
    object-fit: cover;
    object-position: center;

    @include mediaMinMax(1025, $normal) {
      width: vw-full(497);
      height: vw-full(497);
      padding: vw-full(7);
    }

    &_isMobile {
      display: block;
      overflow: initial;
      width: 224px;
      height: 224px;
      padding: 0;
      margin: 0 auto;
      object-fit: contain;
      box-shadow: initial;
    }
  }

  &__veil-video {
    z-index: 5;
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;

    @include media($small) {
      display: none;
    }
  }

  &__description {
    width: 55%;
    overflow-y: auto;
    max-height: 497px;
    padding-top: 20px;

    @include mediaMinMax(1025, $normal) {
      max-height: vw-full(497);
    }

    &_isMobile {
      width: 100%;
      overflow: initial;
      max-height: initial;
    }

    &::-webkit-scrollbar {
      width: 0;
      background-color: rgba($white-color, 0);
    }
  }
}
</style>
